import { cn } from "@/lib/utils";

export function ProductCardSkeleton() {
  return (
    <div className="flex flex-col rounded-t-md bg-[#FDFAF7] p-1">
      <div className="aspect-3/4 animate-pulse rounded-md bg-[#F0E0C7]/60" />
      <div className="mt-2 space-y-2 px-1 pb-2">
        <div className="h-4 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="h-5 w-20 animate-pulse rounded bg-[#F0E0C7]/60" />
      </div>
    </div>
  );
}

interface ProductListingSkeletonProps {
  showSearch?: boolean;
  className?: string;
  itemCount?: number;
}

export default function ProductListingSkeleton({
  showSearch = false,
  className = "grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
  itemCount = 8,
}: Readonly<ProductListingSkeletonProps>) {
  return (
    <>
      {showSearch ? (
        <div className="mb-4">
          <div className="h-10 w-full animate-pulse rounded-full bg-[#F0E0C7]/60" />
        </div>
      ) : null}

      <div className={cn(className)}>
        {Array.from({ length: itemCount }).map((_, index) => (
          <ProductCardSkeleton key={`product-card-${index}`} />
        ))}
      </div>
    </>
  );
}
